export default __webpack_public_path__ + "static/Roboto-Bold-29d0602f3c74d2be2107889818d85108.ttf";